import { render } from "./Feedback.vue?vue&type=template&id=10f77c78&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=10f77c78&lang=sass&scoped=true"
import "./Feedback.vue?vue&type=style&index=1&id=10f77c78&lang=sass"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f77c78"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn});
